export const routesAuth = [
  {
    path: "/login",
    name: "login",
    meta: { layout: "blank", public: true },
    component: () => import("@/views/auth/login.vue"),
  },
  {
    path: "/logout",
    name: "logout",
    meta: { layout: "blank", public: true },
    component: () => import("@/views/auth/logout.vue"),
  },
  {
    path: "/not-authorized",
    name: "not-authorized",
    meta: { layout: "blank", public: true },
    component: () => import("@/views/auth/not-authorized.vue"),
  },
  {
    path: "/offline",
    name: "misc-offline",
    component: () => import("@/pages/Offline.vue"),
    meta: { layout: "blank", public: true },
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    meta: { layout: "blank", public: true },
    component: () => import("@/views/auth/forgot-password.vue"),
  },
  {
    path: "/reset-password",
    name: "reset-password",
    meta: { layout: "blank", public: true },
    component: () => import("@/views/auth/reset-password.vue"),
  },
  {
    path: "/register",
    name: "register",
    meta: { layout: "blank", public: true },
    component: () => import("@/views/auth/register.vue"),
  },
]
